var _module = require('../module');

require('angular-ui-router');
require('../window-height');
require('../../services/lr-touch');
require('../../services/analytics');

_module.requires.push('ui.router');

_module.component('accountVerificationSuccess', {
    controllerAs: 'avs',
    controller: [
        '$log',
        '$timeout',
        '$interval',
        '$stateParams',
        '$analytics',

        function name($log, $timeout, $interval, $stateParams, $analytics) {
            var _this = this;
            var delay = 8000;
            var to = $timeout(function () { _this.redirect(); }, delay);

            this.seconds = delay / 1000;

            var interval = $interval(function onInterval() {
                _this.seconds--;
            }, 1000, this.seconds);

            $analytics.eventTrack('Nest User Verified', {
                Type: $stateParams.type
            });

            // Functions
            this.redirect = function redirect() {
                $timeout.cancel(to);

                if($stateParams.redirect) {
                    window.location = $stateParams.redirect;
                } else {
                    window.location = '/';
                }
            };
        }
    ],
    template: require('./index.html')
});
